module.exports = __webpack_public_path__ + "img/volume.138e717d.svg";